/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mcp_Servers_Test_SuccessInputs */



/**
* | output |
* | --- |
* | "Server is healthy with {count} tools." |
*
* @param {Mcp_Servers_Test_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_test_success = /** @type {((inputs: Mcp_Servers_Test_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Test_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Server erreichbar mit ${i?.count} Tools.`)
	return /** @type {LocalizedString} */ (`Server is healthy with ${i?.count} tools.`)
});